import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Loader from "./component/Loader/Loader";
import Pricing from "./pages/Pricing/Pricing";
import ManageSubscription from "./pages/Manage Subscription/ManageSubscription";
import Support from "./pages/Support/Support";
import Login from "./pages/Login/Login";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutWrapper from "./pages/Checkout/CheckoutWrapper";
import Download from "./pages/Download/Download";
import Home from "./pages/Home/Home";
import axios from "axios";
import PublicRoute from "./protected/PublicRoute";
import ProtectedRoute from "./protected/ProtectedRoute";
import Demo from "./pages/Demo/Demo";
import WebApp from "./pages/WebApp/WebApp";
import PathTracker from "./protected/PathTracker";
import ScrollToTop from "./component/ScrollTop";
import HowItWorks from "./pages/Video/HowitWorks";
import PrivacyPolicy from "./pages/Policies/PrivacyPolicy";
import TermsOfService from "./pages/Policies/TermsOfService";
import DataProcessingTerms from "./pages/Policies/DataProcessingTerms";
import Blog from "./pages/Blog/Blog";
import BlogPost from "./pages/Blog/BlogPost";
import { trackEvent } from "./lib/mixpanel";
import Usage from "./pages/Usage/Usage";

const stripePromise = loadStripe(
  "pk_test_51RD0PSHDfRa9wddpD2RGVgnLUWgBy8pV7KkgCWZK1aHPPuH59j35mmQQ6jWCygfgy2auHVEU7xw3BzEwmFmKes0500Zv74aIY0"
);
axios.defaults.withCredentials = true;
function App() {
  // useEffect(() => {
  //   const disableRightClick = (e) => e.preventDefault();

  //   const handleKeyDown = (e) => {
  //     if (
  //       e.key === "F12" ||
  //       (e.ctrlKey && e.shiftKey && e.key === "I") ||
  //       (e.ctrlKey && e.shiftKey && e.key === "C") ||
  //       (e.ctrlKey && e.shiftKey && e.key === "J")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   const detectContextMenu = (e) => {
  //     e.preventDefault();
  //     console.log("Right-click is disabled");
  //   };

  //   document.addEventListener("contextmenu", detectContextMenu);
  //   document.addEventListener("keydown", handleKeyDown);

  //   const detectDevTools = () => {
  //     const devToolsOpen = /./;
  //     devToolsOpen.toString = function () {
  //       console.log("Developer tools are disabled");
  //     };
  //     console.log(devToolsOpen);
  //   };

  //   detectDevTools();
  //   return () => {
  //     document.removeEventListener("contextmenu", detectContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    trackEvent("app_opened");
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        progressClassName="toastProgress"
        className={"custom-toast-container"}
      />
      <PathTracker />
      <Routes>
        <Route
          path="*"
          element={
            isLoading ? (
              <div className="w-full">
                <Loader />
              </div>
            ) : (
              <div className=" tracking-[-0.015em] ">
                <Home />
              </div>
            )
          }
        />

        <Route path="/demo" element={<Demo />} />
        <Route
          path="/app"
          element={
            <ProtectedRoute>
              <WebApp />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pricing"
          element={
            <div className=" tracking-[-0.015em]">
              <Pricing />
            </div>
          }
        />
        <Route
          path="/help"
          element={
            <div className=" tracking-[-0.015em]">
              <Support />
            </div>
          }
        />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/download"
          element={
            <div className=" tracking-[-0.015em] ">
              <Download />
            </div>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <ManageSubscription />
            </ProtectedRoute>
          }
        />
        <Route
          path="/usage"
          element={
            <ProtectedRoute>
              <Usage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkout/:planId/:clientSecret"
          element={
            <div className="max-w-screen-2xl mx-auto  ">
              <CheckoutWrapper stripePromise={stripePromise} />
            </div>
          }
        />

        <Route
          path="/how-it-works"
          element={
            <div className=" tracking-[-0.015em]">
              <HowItWorks />
            </div>
          }
        />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/data-processing-terms" element={<DataProcessingTerms />} />

        <Route path="/help/all" element={<Blog />} />
        <Route path="/help/:slug" element={<BlogPost />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
